import "./DailyWTBRequests.module.css";
import Header from "@/reusable_sections/Header";
import Showcase from "./sections/Showcase";
import Requests from "./sections/Requests";
import MembershipRequest from "./sections/MembershipRequest";
import Footer from "@/reusable_sections/Footer";
export default function DailyWTBRequestsPage() {
  return <div>
      <Header />
      <Showcase />
      <Requests />
      <MembershipRequest />
      <Footer />
    </div>;
}